import { render, staticRenderFns } from "./PieChartFilterable.vue?vue&type=template&id=e0825b9c"
import script from "./PieChartFilterable.vue?vue&type=script&lang=ts"
export * from "./PieChartFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports